import type { Maybe } from 'graphql/jsutils/Maybe';
import { toLower } from 'lodash';

type Options = {
  ignoreCase?: boolean;
};

/**
 * Safely compares two strings. Ignore case if needed
 */
export function areStringsEqual(
  str1?: Maybe<string>,
  str2?: Maybe<string>,
  { ignoreCase }: Options = {},
) {
  if (!str1 || !str2) {
    return false;
  }

  if (ignoreCase) {
    return toLower(str1) === toLower(str2);
  }

  return str1 === str2;
}
